import axios from '../axios'

const patchReserveAvailableApi = async (teacherId, startAt, endAt) => {
    return await axios.patch(`/api/events/reserve-available`, { teacherId, startAt, endAt })
}

export default patchReserveAvailableApi